'use strict';

angular.module('uniromaLandingApp').controller('EccezioniDetailController', 
		['$scope', '$rootScope', '$stateParams', 'entity', 'Eccezioni',function ($scope, $rootScope, $stateParams, entity, Eccezioni) {
        $scope.eccezioni = entity;
        $scope.load = function (id) {
            Eccezioni.get({id: id}, function(result) {
                $scope.eccezioni = result;
            });
        };
        $rootScope.$on('uniromaLandingApp:eccezioniUpdate', function(event, result) {
            $scope.eccezioni = result;
        });
    }]);
